import React, { useState, useEffect } from "react";
import { TextSwitch } from "../../components/TextSwitch/TextSwitch";
import {
  COURSES_LABEL,
  CERTIFICATIONS_LABEL,
  FORMATION_LABEL,
} from "../../constants/Dictionary";
import { StyledFormation } from "./Formation.styled";
import { Courses } from "./Courses/Courses";
import {
  FormationTypeEnum,
  PermissionsEnum,
} from "../../constants/AppConstants";
import { Certifications } from "./Certifications/Certifications";
import { AlignmentEnum, PageNames } from "../../types/AppTypes";
import { DoubleStructure } from "../../components/core/DoubleStructure/DoubleStructure";
import { roleHasPermission } from "../../utils/roleAuth.utils";
import { useAppSelector } from "../../hooks/store.hook";
import { useBreadCrumb } from "../../hooks/useBreadCrumbs.hooks";
import { useDispatch } from "react-redux";
import { setTabsFormation } from "../../stores/actions/formation.actions";

export const Formation = () => {
  const dispatch = useDispatch();
  const { profile } = useAppSelector((state) => state.user);

  const { tabsFormation } = useAppSelector((state) => state.formation);

  const formationTypeOptions = [
    { value: FormationTypeEnum.COURSE, label: COURSES_LABEL },
    { value: FormationTypeEnum.CERTIFICATION, label: CERTIFICATIONS_LABEL },
  ];
  const [addLink, setAddLink] = useState<React.ReactNode | null>(null);

  useBreadCrumb([
    {
      name: FORMATION_LABEL,
      pathName: PageNames.FORMATION,
    },
  ]);

  useEffect(() => {
    if (formationTypeOptions.length > 0 && !tabsFormation?.value) {
      dispatch(setTabsFormation(formationTypeOptions[0]));
    }
  }, [formationTypeOptions, tabsFormation]);

  return (
    <StyledFormation>
      <DoubleStructure
        verticalAlignment={AlignmentEnum.CENTER}
        variant="primary"
      >
        <TextSwitch
          selectedOption={tabsFormation}
          setSelectedOption={(option) => dispatch(setTabsFormation(option))}
          options={formationTypeOptions}
        />
        {roleHasPermission(profile, PermissionsEnum.EDIT_TECH_FORMATION) &&
          addLink}
      </DoubleStructure>
      <div className="formation-content">
        {tabsFormation?.value === FormationTypeEnum.COURSE && (
          <Courses addLink={setAddLink} />
        )}
        {tabsFormation?.value === FormationTypeEnum.CERTIFICATION && (
          <Certifications addLink={setAddLink} />
        )}
      </div>
    </StyledFormation>
  );
};
